import { createContainer } from './create';
import { Container, UnionToIntersection } from './types';

/* @__NO_SIDE_EFFECTS__ */
export const mergeContainers = <Containers extends Container[]>(
  _: Containers,
  name?: string
): Container<UnionToIntersection<Containers[number]['__deps']>> => {
  return createContainer(name);
};
